<div class="loader-wrap">
  <span [class.hide]="!(loader | async)" class="loader" [class.small]="small"></span>
</div>
